import React from 'react';
import PropTypes from 'prop-types';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from 'primereact/checkbox';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory, useLocation } from "react-router-dom";
import Paginator from '../../../../../../components/Paginator';
import { parse, toSortOrder, sortUrl } from '../../../../../../utils/UrlUtil';
import { getUserLanguage } from '../../../../../../utils/LanguageUtil';
import ValidImportDefinitionHeader from './ValidImportDefinitionHeader';
import { connectionShape } from '../../../../../../components/prop-types';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  M: {
    id: 'attrs.gender.M',
    defaultMessage: 'Male',
  },
  F: {
    id: 'attrs.gender.F',
    defaultMessage: 'Female',
  },
  U: {
    id: 'attrs.gender.U',
    defaultMessage: 'Unspecified',
  },
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  email: { id: 'attrs.email', defaultMessage: 'Email' },
  gender: { id: 'attrs.gender', defaultMessage: 'Gender' },
  locale: { id: 'lbl.locale', defaultMessage: 'Locale' },
  internal: { id: 'attrs.candidateType.INTERNAL', defaultMessage: 'Internal Employee' },
});

const nameTemplate = (rowData) => `${rowData.firstName} ${rowData.lastName}`;

const respondentTypeTemplate = (rowData) => <Checkbox checked={rowData.ownEmployee} />;

const languageTemplate = (rowData, col) => {
  const language = getUserLanguage(rowData.locale, col.translatedTags);
  return language.label;
};

const genderTemplate = (rowData, { formatMessage }) => {
  if (rowData.gender === null || rowData.gender === undefined) {
    return formatMessage(messages.U);
  }
  return formatMessage(messages[rowData.gender]);
};

const ValidImportDefinitionList = ({ connection: { edges, totalCount, indexFrom, indexTo, pageInfo }, loading }) => {
  const history = useHistory();
  const location = useLocation();
  const { formatMessage } = useIntl();

  const { translatedTags } = useSelector((state) => state.i18n);

  const onSortChange = (event) => {
    sortUrl(event, location, history);
  };

  const params = parse(location.search);
  const { sort = {} } = params;
  const { sortBy, sortDir } = sort;

  // data list
  const listRows = edges.map(({ node }) => ({
    ...node,
  }));

  // header
  const nameHeader = formatMessage(messages.name);
  const emailHeader = formatMessage(messages.email);
  const genderHeader = formatMessage(messages.gender);
  const localeHeader = formatMessage(messages.locale);
  const respondentTypeHeader = formatMessage(messages.internal);

  // footer
  const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <ValidImportDefinitionHeader />
          <DataTable
            value={listRows}
            footer={footer}
            responsive
            sortField={sortBy}
            sortOrder={toSortOrder(sortDir)}
            onSort={onSortChange}
            lazy
            loading={loading}
          >
            <Column field="email" header={emailHeader} sortable />
            <Column field="gender" header={nameHeader} body={nameTemplate} sortBy="firstName" />
            <Column field="gender" header={genderHeader} body={genderTemplate} formatMessage={formatMessage} />
            <Column field="locale" header={localeHeader} body={languageTemplate} translatedTags={translatedTags} />
            <Column field="status" header={respondentTypeHeader} body={respondentTypeTemplate} sortBy="firstName" />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

ValidImportDefinitionList.propTypes = {
  connection: connectionShape.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ValidImportDefinitionList;
